export default "__VITE_ASSET__DYwGQgxc__"